import React from "react";
import "../Components/Css/Connect.css";
import Footer from "./Footer";
import Navigation from "./Navigation";
import Instagram from "./Assets/instagram.svg";
import Twitter from "./Assets/twitter.svg";
import Github from "./Assets/github.svg";
import Linkedin from "./Assets/linkedin.svg";

const Connect = () => {
  const SocialMedia = () => {
    return (
      <div>
        <section className="socialmedia">
          <div className="socialCard">
            <h1 className="cardHeading">Social Media</h1>
            <p className="subHeading">Connect With Me</p>
            <div className="icons">
              <a href="https://www.instagram.com/iamsaurabh.dev">
                <img src={Instagram} alt="Instagram Logo" />
              </a>
              <a href="https://github.com/SaurabhSonde">
                <img src={Github} alt="Github Logo" />
              </a>
              <a href="https://twitter.com/sonde_saurabh">
                <img src={Twitter} alt="Twitter Logo" />
              </a>
              <a href="https://www.linkedin.com/in/saurabh-sonde-32bb38190">
                <img src={Linkedin} alt="linkedin" />
              </a>
            </div>
          </div>
        </section>
      </div>
    );
  };

  return (
    <div>
      <Navigation />
      {SocialMedia()}
      <Footer />
    </div>
  );
};

export default Connect;
